import { render } from "./FaqCategories.vue?vue&type=template&id=4d6295b0&scoped=true"
import script from "./FaqCategories.vue?vue&type=script&lang=js"
export * from "./FaqCategories.vue?vue&type=script&lang=js"

import "./FaqCategories.vue?vue&type=style&index=0&id=4d6295b0&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d6295b0"]])

export default __exports__